export const footerData = {
  social: [
    {
      icon: 'ecs-font-icon-soc-facebook',
      label: 'Follow us on Facebook.',
      link: '//facebook.com/experian',
    },
    {
      icon: 'ecs-font-icon-soc-twitter',
      label: 'Follow us on  Twitter.',
      link: '//twitter.com/Experian_US',
    },
    {
      icon: 'ecs-font-icon-soc-instagram',
      label: 'Follow us on Instagram.',
      link: '//instagram.com/experian',
    },
    {
      icon: 'ecs-font-icon-soc-youtube',
      label: 'Follow us on Youtube.',
      link: '//www.youtube.com/experian',
    },
  ],
  mainCols: [
    {
      column: 'Credit',
      links: [
        {
          link: '/consumer-products/credit-monitoring.html',
          title: 'Free credit monitoring',
        },
        {
          link: '/consumer-products/experian-equifax-transunion-credit-report-and-score.html',
          title: '3-bureau reports and FICO<sup>®</sup> Scores',
        },
        {
          link: '/help/annual-credit-report.html',
          title: 'Annual credit report',
        },
        {
          link: '/protection/creditlock/',
          title: 'Experian CreditLock',
        },
        {
          homepage: true,
          link: 'https://www.experian.com/ncaconline/creditreport?type=paid',
          title: 'Credit file disclosure',
        },
        {
          homepage: true,
          link: 'https://imc-us3.csid.co/enrollment/1?RTN=90000232',
          title: 'Credit score disclosure',
          attributes: {
            rel: 'nofollow',
          },
        },
        {
          homepage: false,
          link: '/blogs/ask-experian/credit-education/report-basics/understanding-your-experian-credit-report/',
          title: 'Understanding credit reports',
        },
        {
          homepage: false,
          link: '/blogs/ask-experian/credit-education/improving-credit/how-to-fix-a-bad-credit-score/',
          title: 'How to improve your credit score',
        },
      ],
    },
    {
      column: 'Personal finance',
      links: [
        {
          link: '/blogs/ask-experian/category/credit-cards/credit-card-reviews/',
          title: 'Credit card reviews',
        },
        {
          link: '/blogs/ask-experian/category/loans/loan-reviews/',
          title: 'Loan reviews',
        },
        {
          link: '/blogs/ask-experian/category/insurance/insurance-reviews/',
          title: 'Car insurance reviews',
        },
        {
          link: '/blogs/ask-experian/category/personal-finance/budgeting/',
          title: 'Budgeting',
        },
        {
          link: '/blogs/ask-experian/category/personal-finance/saving/',
          title: 'Saving',
        },
        {
          link: '/blogs/ask-experian/category/personal-finance/mortgage/',
          title: 'Mortgage & renting',
        },
      ],
    },
    {
      column: 'Support',
      links: [
        {
          link: '/blogs/ask-experian/credit-education/preventing-fraud/security-freeze/',
          title: 'How to freeze your credit file',
        },
        {
          link: '/blogs/ask-experian/credit-education/faqs/how-to-dispute-credit-report-information/',
          title: 'How to dispute info on your credit report',
        },
        {
          link: '/help/identity-theft-victim-assistance.html',
          title: 'Identity theft victim assistance',
        },
        {
          link: '/reportaccess/',
          title: 'Support for denied credit',
        },
        {
          link: '/blogs/ask-experian/credit-education/faqs/experian-document-upload-service/',
          title: 'Upload a document to Experian',
        },
        {
          link: '/help/',
          title: 'Experian customer support',
        },
      ],
    },
    {
      column: 'Experian for businesses',
      links: [
        {
          link: '/small-business/business-credit-reports',
          title: 'Business credit reports',
        },
        {
          link: '/small-business/credit-profile',
          title: 'Customer credit profiles',
        },
        {
          link: '/business-services/decisioning/',
          title: 'Decisioning software',
        },
        {
          link: '/business/solutions/fraud-management',
          title: 'Business fraud management',
        },
        {
          link: '/healthcare/',
          title: 'Healthcare solutions',
        },
        {
          link: '/mortgage/',
          title: 'Mortgage solutions',
        },
      ],
    },
  ],
  legal: [
    {
      link: '/corporate/legalterms.html',
      title: 'Legal Terms & Conditions',
    },
    {
      link: '/privacy/index.html',
      title: 'Privacy Center',
    },
    {
      link: '/privacy/us-consumer-data-privacy-policy',
      title: 'U.S. Data Privacy Policy',
    },
    {
      link: '//www.experianplc.com/media/news',
      title: 'Press',
      target: '_blank',
      rel: 'noopener',
    },
    {
      link: '/privacy/opt-out-targeted-advertising.html',
      title: 'Ad Choices',
      target: '_blank',
    },
    {
      link: '/corporate/careers-home.html',
      title: 'Careers',
    },
    {
      link: '//www.experianplc.com/',
      title: 'Investor Relations',
      target: '_blank',
      rel: 'noopener',
    },
    {
      link: '/contact/personal-services-contacts.html',
      title: 'Contact Us',
    },
  ],
};
